export var SubscriberPackageDelimiter;
(function (SubscriberPackageDelimiter) {
    SubscriberPackageDelimiter["V_PIPE"] = "|";
    SubscriberPackageDelimiter["EMPTY"] = "";
})(SubscriberPackageDelimiter || (SubscriberPackageDelimiter = {}));
